export default "__VITE_ASSET__Bra6YmX9__"